import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { MatCardModule } from '@angular/material/card'
import { MatDialogModule } from '@angular/material/dialog'
import { MatSnackBarModule } from '@angular/material/snack-bar'
import { PipesModule } from '@mmx/pipes'
import { TranslateModule } from '@ngx-translate/core'

import { DatePickerDialogModule } from '../../date-picker-dialog'
import { InvoiceSubtitleComponent } from './invoice-subtitle.component'

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    MatDialogModule,
    MatSnackBarModule,
    PipesModule,
    TranslateModule,
    DatePickerDialogModule,
  ],
  declarations: [InvoiceSubtitleComponent],
  exports: [InvoiceSubtitleComponent],
})
export class InvoiceSubtitleModule {}
